import { PageTitle } from '../../../components/texts';
import { useTablePagination } from '../../../components/Table';
import NavTabs from '../../../components/navTabs/NavTabs';
import { Navigate, NavLink, Route, Routes, useLocation } from 'react-router-dom';
import TyAdvancedSearchContracts from './components/advanceSearch/contracts';
import apiTransformationsContracts from './components/advanceSearch/contracts/apiTransformationsMpsv';
import TyAdvancedSearchPpv from './components/advanceSearch/ppv';
import apiTransformationsPpv from './components/advanceSearch/ppv/apiTransformationsMpsv';
import TyAdvancedSearchRegzec from './components/advanceSearch/regzec';
import apiTransformationsRegzec from './components/advanceSearch/regzec/apiTransformationsMpsv';
import Card from '../../../components/Layout/Card';
import useSingleSearchString from '../../../hooks/UrlParamsHandler/useSingleSearchString';
import apiBuilder from '../../../components/TyAdvancedSearch/Libs/apiBuilder';
import JmhzContractsPage from './contracts.page';
import JmhzPpvPage from './ppv.page';
import { Query } from '@feathersjs/feathers';
import RegzecPage from './regzec.page';
import RegzecExportPage from './export.page';

const JmhzPage = () => {
  const [queryString, setQuery] = useSingleSearchString('search');
  const { setPageStart } = useTablePagination();
  const { pathname } = useLocation();
  const currentPath = pathname.split('/').slice(-1)[0];
  const search = queryString ? JSON.parse(queryString) : { dateFormatFrom: '2026-01-01T00:00:00.000Z' };
  let AdvancedSearchComponent = null;
  let query: Query = {};

  switch (currentPath) {
    case 'contracts':
      AdvancedSearchComponent = TyAdvancedSearchContracts;
      query = apiBuilder(search, apiTransformationsContracts);
      break;
    case 'emptyppv':
    case 'ppv':
      AdvancedSearchComponent = TyAdvancedSearchPpv;
      query = apiBuilder(search, apiTransformationsPpv);
      break;
    case 'export':
    case 'regzec':
      AdvancedSearchComponent = TyAdvancedSearchRegzec;
      query = apiBuilder(search, apiTransformationsRegzec);
      break;
  }

  const onAdvancedSearch = (values: object) => {
    const filteredValues = Object.fromEntries(
      Object.entries(values).filter(([, value]) => {
        if (Array.isArray(value)) {
          return value.length > 0;
        }
        return value;
      })
    );
    setQuery(JSON.stringify(filteredValues));
    setPageStart(0);
  };

  return (
    <>
      <PageTitle>
        <span className="pl-10">JMHZ Tabulka</span>
      </PageTitle>

      <Card className="my-6">
        <div className="flex align-center gap-10 flex-wrap items-center">
          <NavTabs className="grow">
            <NavLink
              key="contracts-tab"
              to="contracts"
              className={({ isActive }) => (isActive ? 'text-secondary font-semibold active' : 'text-secondary-400')}
            >
              Smlouvy bez PPV
            </NavLink>
            <NavLink
              key="emptyppv-tab"
              to="emptyppv"
              className={({ isActive }) => (isActive ? 'text-secondary font-semibold active' : 'text-secondary-400')}
            >
              PPV bez smlouvy
            </NavLink>
            <NavLink
              key="ppv-tab"
              to="ppv"
              className={({ isActive }) => (isActive ? 'text-secondary font-semibold active' : 'text-secondary-400')}
            >
              Pracovněprávní vztahy
            </NavLink>
            <NavLink
              key="regzec-tab"
              to="regzec"
              className={({ isActive }) => (isActive ? 'text-secondary font-semibold active' : 'text-secondary-400')}
            >
              Přehled podání
            </NavLink>
            <NavLink
              key="export-tab"
              to="export"
              className={({ isActive }) => (isActive ? 'text-secondary font-semibold active' : 'text-secondary-400')}
            >
              Export
            </NavLink>
          </NavTabs>
          {AdvancedSearchComponent && (
            <AdvancedSearchComponent
              pageTitle="Pokročilé vyhledávání MPSV"
              className="shrink-0"
              setInitialValues={(srch) => onAdvancedSearch(srch ?? {})}
              initialValues={search}
            />
          )}
        </div>
      </Card>

      <Routes>
        <Route path="*" element={<Navigate to="contracts" replace />} />
        <Route path="contracts" element={<JmhzContractsPage query={query} />} />
        <Route path="ppv" element={<JmhzPpvPage query={query} />} />
        <Route path="emptyppv" element={<JmhzPpvPage query={{ ...query, 'contracts.id': { $null: true } }} />} />
        <Route path="regzec" element={<RegzecPage query={query} />} />
        <Route path="export" element={<RegzecExportPage />} />
      </Routes>
    </>
  );
};

export default JmhzPage;
